import { Link } from "react-router-dom"

import { CorePaymentMethod, Maybe } from "@oysterhr/schema"
import { Text, Alert } from "@oysterhr/ui"

import { isAchAndVerifiable } from "../utils"
import { useTranslation } from "react-i18next"

interface WarningVerifyAlertProps {
  paymentMethod?: Maybe<CorePaymentMethod>
}

export const WarningVerifyAlert = ({ paymentMethod }: WarningVerifyAlertProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage", {
    keyPrefix: "banners.warningVerify",
  })

  return paymentMethod && isAchAndVerifiable(paymentMethod) ? (
    <Alert variation="warning">
      <Alert.Icon />
      <Alert.Content>
        <div>
          <Text className="font-semibold">{t("title")}</Text>
          <Text>{t("content")}</Text>

          <Link
            className="font-normal underline"
            to="verify-stripe-ach-payment-method"
            state={{
              paymentMethod: { ...paymentMethod },
            }}
          >
            {t("link")}
          </Link>
        </div>
      </Alert.Content>
    </Alert>
  ) : null
}
